export default function getLocationSelectionEvent(event, location, onLocationSelection) {
  event.preventDefault();
  event.stopPropagation();
  onLocationSelection(location);
}
